export default "__VITE_ASSET__BcWAB6o6__"